/**
 *  AenaSearch script file
**/

import Searcher from '@/components/searcher/Searcher.vue'
import { GETTERS } from '@/store'
import { mapGetters } from 'vuex'
import setDeviceWidthClass from '@/mixins/setDeviceWidthClass'

export default {
  name: 'app-aenaSearch',
  mixins: [setDeviceWidthClass],
  components: {
    Searcher
  },
  props: {
    hidden: {
      type: Boolean,
      default: false
    },
    search: {
      type: String,
      required: false
    },
    view: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      active: false,
      focus: false
    }
  },
  computed: {
    ...mapGetters({
      airport: GETTERS.GET_AIRPORT,
      isMobile: GETTERS.GET_IS_MOBILE
    }),
    hasRoute () {
      return this.airport.has_graph
    }
  },
  methods: {
    setActive (value) {
      this.active = value
    },
    onFocus () {
      this.active = true
      this.focus = true
      this.$emit('onFocus')
    },
    onEnterKey () {
      this.$emit('onEnterKey')
    },
    onBlur () {
      if (!this.isMobile) {
        this.focus = false
      }
      this.$emit('onBlur')
    },
    goToRoute () {
      this.focus = false
      this.$emit('onSelect', { component: 'aena-route-pre' })
    },
    goBack () {
      this.focus = false
      this.$emit('onBack')
    }
  }
}
